export default "__VITE_ASSET__Btc5iIUG__"